import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TTreatment } from '@shared/interfaces/TProject';
import { TBaseSettingsTabParams } from '../project-settings.component';

@Component({
  selector: 'app-treatment-goals',
  templateUrl: './treatment-goals.component.html',
  styleUrls: ['./treatment-goals.component.scss'],
})
export class TreatmentGoalsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TreatmentGoalsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TBaseSettingsTabParams
  ) {
    this.params = data;
  }
  public params: TBaseSettingsTabParams;

  public newTreatmentGoalData: TTreatment = {
    description: '',
    name: '',
  };

  public getTreatmentGoals(): TTreatment[] {
    return this.params.selectedProject?.treatment_goals ?? [];
  }

  public add() {
    if (
      this.params.selectedProject !== undefined &&
      this.params.selectedProject.treatment_goals === undefined
    ) {
      this.params.selectedProject.treatment_goals = [];
      this.params.selectedProject?.treatment_goals.push(
        structuredClone(this.newTreatmentGoalData)
      );
    } else {
      this.params.selectedProject?.treatment_goals.push(
        structuredClone(this.newTreatmentGoalData)
      );
    }
  }

  private _isNameDuplicated(
    treatment_goals: TTreatment[] | undefined,
    name: string
  ): boolean {
    return (treatment_goals ?? []).map((r) => r.name).includes(name);
  }

  public addAvailable(): boolean {
    const formIsValid =
      this.newTreatmentGoalData.name !== '' &&
      this.newTreatmentGoalData.description !== '';
    const belowLimit = this.params.selectedProject?.treatment_goals
      ? this.params.selectedProject?.treatment_goals.length < 9
      : true;
    return (
      formIsValid &&
      !this._isNameDuplicated(
        this.params.selectedProject?.treatment_goals,
        this.newTreatmentGoalData.name
      ) &&
      belowLimit
    );
  }

  public remove(region: TTreatment): void {
    if (
      this.params.selectedProject !== undefined &&
      this.params.selectedProject.regions1 !== undefined
    ) {
      const idx: number = this.params.selectedProject.treatment_goals.findIndex(
        (r) => r.name === region.name
      );
      this.params.selectedProject.treatment_goals.splice(idx, 1);
    }
  }

  ngOnInit(): void {}
}
